import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "news",
  class: "py-16 bg-gascon-gray"
}
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" }
const _hoisted_4 = { class: "inline-flex items-center justify-center w-12 h-12 border-b-2 border-gascon-gold text-gascon-gold font-bold text-lg mb-6" }
const _hoisted_5 = { class: "text-xl font-bold text-gascon-blue mb-4" }
const _hoisted_6 = { class: "text-gascon-blue/80 leading-relaxed text-justify" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "section-title text-gascon-blue" }, "Dans le gras du sujet", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayNews, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id || index,
            class: "text-center"
          }, [
            _createCommentVNode(" Number badge "),
            _createElementVNode("div", _hoisted_4, _toDisplayString(String(index + 1).padStart(2, '0')), 1 /* TEXT */),
            _createCommentVNode(" Title "),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(item.title), 1 /* TEXT */),
            _createCommentVNode(" Content "),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.content), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}